/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateAmenitiesRequest } from '../../models/update-amenities-request';
import { UpdateAmenitiesResponse } from '../../models/update-amenities-response';

export interface PutTenantAmenities$Params {
  'Active-Tenant-Identifier': string;
      body: UpdateAmenitiesRequest
}

export function putTenantAmenities(http: HttpClient, rootUrl: string, params: PutTenantAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateAmenitiesResponse>> {
  const rb = new RequestBuilder(rootUrl, putTenantAmenities.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateAmenitiesResponse>;
    })
  );
}

putTenantAmenities.PATH = '/tenant-amenities';
